/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Remove_DownloadInputs */

const en_mobile_remove_download = /** @type {(inputs: Mobile_Remove_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove download`)
};

const es_mobile_remove_download = /** @type {(inputs: Mobile_Remove_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar descarga`)
};

/**
* | output |
* | --- |
* | "Remove download" |
*
* @param {Mobile_Remove_DownloadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_remove_download = /** @type {((inputs?: Mobile_Remove_DownloadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Remove_DownloadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_remove_download(inputs)
	return en_mobile_remove_download(inputs)
});